// A trade's time of day ("10:42 AM"), or an empty string when the broker's file only gave
// the day (Schwab, for example). Kept apart from pnl.js, which the server also reads.
import { currentLocale } from './langState';

export function tradeTime(t) {
  if (t.timeUnknown) return '';
  return new Date(t.date).toLocaleTimeString(currentLocale(), { hour: 'numeric', minute: '2-digit' });
}
